import { render, staticRenderFns } from "./MailSender.vue?vue&type=template&id=c9c90a46&scoped=true"
import script from "./MailSender.vue?vue&type=script&lang=js"
export * from "./MailSender.vue?vue&type=script&lang=js"
import style0 from "./MailSender.vue?vue&type=style&index=0&id=c9c90a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c90a46",
  null
  
)

export default component.exports